import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-download\"><defs><style type=\"text/css\"></style></defs><path d=\"M842.752 487.104c0.064-2.24 0.192-4.48 0.192-6.784 0-151.808-118.528-274.816-264.704-274.816-106.496 0-198.208 65.28-240.256 159.424a123.072 123.072 0 0 0-70.336-22.016c-70.272 0-127.296 59.136-127.296 132.096 0 12.608 1.728 24.832 4.928 36.416A164.864 164.864 0 0 0 64 654.72c0 90.496 70.656 163.84 157.824 163.84h575.296c89.984 0 162.88-75.712 162.88-169.088 0-76.992-49.536-141.888-117.248-162.368zM645.76 596.032l-105.216 143.296c-6.272 8.512-29.184 8.512-35.328 0L401.728 596.032c-7.616-10.56-0.384-25.664 12.224-25.664h33.792c8.448 0 15.36-7.168 15.36-16V410.112c0-8.832 6.848-16 15.36-16H567.68c8.64 0 15.616 7.168 15.616 16v144.256c0 8.832 6.976 16 15.616 16h34.368c12.864 0 20.224 15.104 12.48 25.664z\" p-id=\"7732\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/download.svg
// module id = +H2/
// module chunks = 0